import request from '@/utils/request'

export function validUserEmpNo(data) {
  return request({
    url: `/users/valid_emp_no`,
    method: 'post',
    data
  })
}
